import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Container, Row, Col, Card, CardBody, CardText } from 'reactstrap';
import PropTypes from 'prop-types';
import { setCurrencyFormat } from '../../../../utils/helpers';


const CustomerTransitionShow = ({ title, dataToShowForDatesSelected }) => {
    const thisMonthData = {};
    return (
        <Col xs="12">
            <Card className="pb-3 show-categ-daily-sales">
                <div className="card__title row " style={{ position: 'relative' }} >
                    <h5 className="bold-text col-md-5">{title}</h5>
                </div>
                <Row>
                    <Col sm={6} md={6} style={{ fontSize: 14 }}><b>Web To Amazon</b></Col>
                    <Col sm={6} md={6} style={{ fontSize: 14 }}>
                        <b>Amazon To Web</b>

                    </Col>
                </Row>
                {dataToShowForDatesSelected.length ? dataToShowForDatesSelected?.
                    map((customer, index) => (<Row key={customer.webToAmazon}>
                        <Col sm={6} md={6}><CardText>{setCurrencyFormat(customer.webToAmazon, false)}</CardText></Col>
                        <Col sm={6} md={6}>
                            <CardText>{setCurrencyFormat(customer.amazonToWeb, false)}</CardText>

                        </Col>
                    </Row>
                    )) : <div className="no-data">No data to display</div>}
            </Card>
        </Col>

    )
}

CustomerTransitionShow.propTypes = {
    title: PropTypes.string,
    dataToShowForDatesSelected: PropTypes.arrayOf({}).isRequired,
    // eslint-disable-next-line react/forbid-prop-types
};
CustomerTransitionShow.defaultProps = {
    title: 'Customer Transition',
}

export default React.memo(CustomerTransitionShow);